import {
  SET_ASSESSMENT_RESULTS,
  SET_ASSESSMENT_RESULTS_SUCCESS,
  SET_ASSESSMENT_RESULTS_ERROR,
  GET_ASSESSMENT_BY_ID,
  GET_ASSESSMENT_BY_ID_SUCCESS,
  GET_ASSESSMENT_BY_ID_ERROR,
} from "./constants";

const initialState = {
  responseObj: null,
  assessmentResults: null,
  profile: null,
  setAssessmentLoading: false,
  setAssessmentData: null,
  // Phase 4 — Assessment templates fetched by id. Keyed by template
  // _id so the same template (typical for Full/Basic seeds shared by
  // many users) is fetched once per session. Loading/error are also
  // per-id so concurrent fetches of different templates don't shadow
  // each other's state.
  templatesById: {},
  templatesLoading: {},
  templatesError: {},
};

function assessment(state = initialState, action) {
  switch (action.type) {
      case SET_ASSESSMENT_RESULTS:
        return {
          ...state,
          assessmentResults: action.assessmentResults,
          responseObj: action.responseObj,
          profile: action.profile,
        };
    case GET_ASSESSMENT_BY_ID:
      return {
        ...state,
        templatesLoading: { ...state.templatesLoading, [action.id]: true },
        templatesError: { ...state.templatesError, [action.id]: null },
      };
    case GET_ASSESSMENT_BY_ID_SUCCESS: {
      const id = action.assessment?._id;
      if (!id) return state;
      return {
        ...state,
        templatesById: { ...state.templatesById, [id]: action.assessment },
        templatesLoading: { ...state.templatesLoading, [id]: false },
        templatesError: { ...state.templatesError, [id]: null },
      };
    }
    case GET_ASSESSMENT_BY_ID_ERROR:
      return {
        ...state,
        templatesLoading: { ...state.templatesLoading, [action.id]: false },
        templatesError: { ...state.templatesError, [action.id]: action.err },
      };
    default:
      return state;
  }
}

export default assessment;
